import { useEffect } from "react";
import { useSearchParams } from "react-router-dom";
import jwtDecode from "jwt-decode";
import { Api } from "@/services";
import { Api_Banking } from "@/services/Api/bankingApiConfig";
import { clearReturnUrl } from "@/utils/postLoginRedirect";

interface ImpersonateTokenPayload {
  sub: string;
  email: string;
  realm_access?: { roles: string[] };
  impersonator?: { id: string; username: string };
  exp: number;
}

function ImpersonateCallback() {
  const [searchParams] = useSearchParams();

  useEffect(() => {
    async function handleImpersonate() {
      const token = searchParams.get("token");
      if (!token) {
        window.location.replace("/login");
        return;
      }

      try {
        const decoded = jwtDecode<ImpersonateTokenPayload>(token);
        const roles = decoded.realm_access?.roles || [];
        const email = decoded.email || "";
        const impersonatorUsername = decoded.impersonator?.username || "";

        localStorage.setItem("barte-auth-token", token);
        localStorage.removeItem("barte-refresh-token");
        clearReturnUrl();
        localStorage.setItem(
          "barte-user-info",
          JSON.stringify({
            email,
            roles,
            bankingStatus: "INACTIVE",
          })
        );
        localStorage.setItem("barte-impersonation", "true");
        localStorage.setItem("barte-impersonator", impersonatorUsername);
        localStorage.setItem("barte-impersonation-exp", String(decoded.exp));

        Api.defaults.headers["Authorization"] = `Bearer ${token}`;
        Api_Banking.defaults.headers["Authorization"] = `Bearer ${token}`;

        try {
          const featureToggleResponse = await Api.get("/users/feature-toggles");
          const updatedFeatureToggles = [...featureToggleResponse.data];
          if (featureToggleResponse.data.includes("disable_paymentlink")) {
            const index = updatedFeatureToggles.findIndex(
              (feature: string) => feature === "view_seller_payment_link"
            );
            if (index !== -1) {
              updatedFeatureToggles.splice(index, 1);
            }
          }
          localStorage.setItem(
            "barte-features-list-user",
            JSON.stringify(updatedFeatureToggles)
          );
        } catch {
          // Feature toggles will be fetched by WithAuth on reload as fallback
        }

        window.location.replace("/");
      } catch {
        window.location.replace("/login");
      }
    }

    handleImpersonate();
  }, [searchParams]);

  return null;
}

export default ImpersonateCallback;
